import React from 'react';
import { Badge } from '../ui/badge';

const MOTIVOS = {
  sumado_a_episodio_activo: 'Se sumó a un episodio activo del mismo cliente y monitor',
  movimientos_ya_incluidos: 'Todos sus movimientos ya estaban en un episodio anterior',
  sin_fecha_confiable: 'Sin movimientos y sin fecha confiable (carga masiva): se sumó al último episodio',
  menos_del_minimo: 'Menos movimientos nuevos que el mínimo del monitor',
  primer_episodio: 'Es el primer episodio del cliente en ese monitor',
};

const fecha = (v) => (v ? new Date(v).toLocaleDateString('es-AR') : '—');
const num = (v) => Number(v || 0).toLocaleString('es-AR');

const Par = ({ label, antes, despues, testid }) => (
  <div className="border border-slate-200 rounded p-2" data-testid={testid}>
    <p className="text-[11px] text-slate-500 leading-tight">{label}</p>
    <p className="text-sm text-slate-900"><span className="text-slate-400">{num(antes)}</span> → <b className="text-lg">{num(despues)}</b></p>
  </div>
);

const Ejemplo = ({ e, i }) => (
  <div className="border border-slate-200 rounded p-2" data-testid={`migracion-ejemplo-${i}`}>
    <p className="text-xs text-slate-700"><b>{e.cliente}</b> · {e.monitor} · mínimo {e.minimo_ocurrencias} · {e.episodios_del_cliente} episodio(s) del cliente</p>
    <table className="w-full text-[11px] mt-1">
      <thead><tr className="text-slate-500 text-left">
        <th>Detección</th><th>Última detección</th><th>Primer mov.</th><th>Último mov. nuevo</th><th>Estado</th><th>Movs.</th><th>Nuevos</th><th />
      </tr></thead>
      <tbody>
        {e.episodios.map((x, j) => (
          <tr key={j} className={x.es_reincidencia ? 'bg-amber-50 font-medium' : ''}>
            <td>{fecha(x.inicio)}</td><td>{fecha(x.ultima_deteccion)}</td>
            <td>{x.movimientos ? fecha(x.primer_movimiento) : '—'}</td><td>{x.movimientos ? fecha(x.ultimo_movimiento_nuevo) : '—'}</td><td>{x.estado}</td>
            <td>{x.movimientos}</td><td>{x.movimientos_nuevos}</td>
            <td>{x.es_reincidencia && <Badge className="bg-amber-600 text-[10px]">Reincidencia</Badge>}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const MigracionEpisodiosFusion = ({ r }) => {
  if (r.reincidencias_antes === undefined) return null;
  return (
    <div className="space-y-3" data-testid="migracion-episodios-fusion">
      <p className="text-sm font-medium text-slate-700">Fusión y reincidencias (antes → después)</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <Par label="Episodios (todos los casos)" antes={r.episodios_total_antes} despues={r.episodios_total_despues} testid="migracion-fusion-total" />
        <Par label="Episodios en casos abiertos" antes={r.episodios_abiertos_antes} despues={r.episodios_abiertos_despues} testid="migracion-fusion-abiertos" />
        <Par label="Reincidencias" antes={r.reincidencias_antes} despues={r.reincidencias_despues} testid="migracion-fusion-reincidencias" />
        <Par label="Episodios sin movimientos" antes={r.episodios_sin_movimientos}
          despues={r.episodios_sin_movimientos_despues} testid="migracion-fusion-sin-movs" />
      </div>
      <div className="text-xs text-slate-600 space-y-0.5" data-testid="migracion-fusion-sumados">
        <p className="font-medium">Detecciones que se suman a otro episodio:</p>
        {Object.entries(r.episodios_fusionados_por_motivo || {}).map(([k, v]) => <p key={k}>· {MOTIVOS[k] || k}: <b>{num(v)}</b></p>)}
      </div>
      <div className="text-xs text-slate-600 space-y-0.5" data-testid="migracion-fusion-motivos">
        <p className="font-medium">Reincidencias que dejan de serlo:</p>
        {Object.entries(r.reincidencias_que_se_pierden || {}).map(([k, v]) => <p key={k}>· {MOTIVOS[k] || k}: <b>{num(v)}</b></p>)}
      </div>
      {(r.reincidencias_por_monitor || []).length > 0 ? (
        <table className="w-full text-xs border border-slate-200 rounded" data-testid="migracion-fusion-por-monitor">
          <thead className="bg-slate-50"><tr className="text-left"><th className="px-2 py-1">Monitor (top 10)</th><th>Antes</th><th>Después</th></tr></thead>
          <tbody>{r.reincidencias_por_monitor.map((m) => (
            <tr key={m.monitor} className="border-t border-slate-100"><td className="px-2 py-1">{m.monitor}</td><td>{m.antes}</td><td>{m.despues}</td></tr>
          ))}</tbody>
        </table>
      ) : (
        <p className="text-xs text-slate-500" data-testid="migracion-fusion-sin-reincidencias">
          No hay reincidencias para mostrar (si la migración ya se ejecutó, no quedan episodios por convertir).
        </p>
      )}
      {(r.ejemplos_reincidencia || []).map((e, i) => <Ejemplo key={i} e={e} i={i} />)}
    </div>
  );
};
